export enum VoiceMailTemplateStatus {
  ACTIVE = 'ACTIVE',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  ARCHIVED = 'ARCHIVED',
}
